import { Link, Text } from '@fluentui/react'
import { formatDateTime } from '../../utils/formatDateTime'

type ConversationLinkCellProps = {
  conversationId: string | null
  createdAt: string
  onOpen: (conversationId: string) => void
}

const ConversationLinkCell = ({ conversationId, createdAt, onOpen }: ConversationLinkCellProps) => {
  if (conversationId === null) {
    return <Text styles={{ root: { color: '#605e5c' } }}>Not linked</Text>
  }
  return (
    <Link onClick={() => onOpen(conversationId)} aria-label={`Open conversation from ${formatDateTime(createdAt)}`}>
      Open conversation
    </Link>
  )
}

export default ConversationLinkCell
